import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import classNames from 'classnames';
import agent from '../agent'
import moment from 'moment'
import QRCode from 'qrcode-react';

import closeLight from '../assets/images/close-light.png'
import closeDark from '../assets/images/close-dark.png'
import project1 from '../assets/images/mickey.jpg'
import companyLogo from '../assets/images/walt_disney_white.png'
import amlogo from '../assets/images/company-client-landing-page-auditionmagiciconplain@2x.png'

import project_details_logo1 from '../assets/images/expanded-project-shape-4@2x.png'
import project_details_logo2 from '../assets/images/check-in-expanded-01-copy-10-shape-5@2x.png'
import project_details_logo3 from '../assets/images/expanded-project-shape-6@2x.png'
import project_details_logo4 from '../assets/images/check-in-expanded-01-copy-10-shape-7@2x.png'
import project_details_logo5 from '../assets/images/expanded-project-shape-8@2x.png'
import project_details_logo6 from '../assets/images/check-in-expanded-01-copy-10-path-6@2x.png'
import project_details_logo7 from '../assets/images/check-in-expanded-01-copy-10-shape-9@2x.png'
import project_details_logo8 from '../assets/images/check-in-expanded-01-copy-10-shape-10@2x.png'

import social_media1 from '../assets/images/check-in-expanded-01-copy-9-path@2x.png'
import social_media2 from '../assets/images/expanded-project-responsive-path-3@2x.png'
import social_media3 from '../assets/images/expanded-project-shape@2x.png'
import social_media4 from '../assets/images/company-landing-page--register-path-2@2x.png'
import social_media5 from '../assets/images/expanded-project-path-3@2x.png'
import social_media6 from '../assets/images/check-in-expanded-01-copy-10-path-4@2x.png'
import social_media7 from '../assets/images/company-client-landing-page--expanded--review-path-5@2x.png'
import social_media8 from '../assets/images/check-in-expanded-01-copy-10-shape-1@2x.png'
import social_media9 from '../assets/images/company-client-landing-page--expanded--review-shape-2@2x.png'
import social_media10 from '../assets/images/check-in-expanded-01-copy-10-shape-3@2x.png'

import qrcode from '../assets/images/expanded-project-responsive-qr-code@2x.png'

class CompanyReview extends Component {
    state = {
        theme: 'dark'
    }

    componentWillMount() {
        const { location, history } = this.props
        const token = new URLSearchParams(location.search).get('token');
        const projectId = new URLSearchParams(location.search).get('project');
        if (!token) {
            history.push('/')   
        } else {
            const project = agent.Project.myProjectByid(token, projectId)
            this.props.onLoad(
                Promise.all([
                    project
                ])
            )
        }
    }

    dateFormat (date) {
        const fdate = moment(date).format("DD - MMM - YYYY")
        return fdate;
      }

    toUpper(value) {
        const val = value ? value.toUpperCase() : '';
        return val;
    }

    render(){
        const { project, location } = this.props
        console.log('render', project)
        return (
            project ?
            <div className="row main-wrapper">
                    <div className="column">
                        <div className="row header large-expand">
                            <div className="row header-details2">
                                <div className="column header-logo2">
                                    <img width="200px" src={companyLogo}/>
                                </div>
                                <div className="column header-description">
                                    <div className="header-title2">AUDITION REVIEW PAGE</div>
                                    <div className="header-desc">PLEASE CLICK THE PROJECT BELOW &amp; ENTER THE CODE PROVIDED TO YOU, TO REVIEW YOUR AUDITIONS</div>
                                </div>
                            </div>
                        </div>
                        <div className="row project-wrapper">
                            <div className="row project-list">
                                <div className="row">
                                    <div className="column small-3 align-right">
                                        <div className="row">
                                            <div className="column large-3 align-right">
                                                <Link to={{
                                                    pathname: '/registration',
                                                    search: location.search
                                                }}>
                                                {
                                                    this.state.theme === 'dark' ?
                                                    <img src={closeDark} width="75px" /> : 
                                                    <img src={closeLight} width="75px" />
                                                }</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="column project">
                                        <button className="large-5" type="button">
                                            <div className="project-border">
                                                <div className="img-holder-1">
                                                    <div className="img-holder-sub-details-1">
                                                        <img src={project.cover_url} />
                                                    </div>
                                                </div>
                                                <div className="project-name2">{project.name}</div>
                                            </div>
                                            <div className="row">
                                                <div className="column large-3 large-centered">
                                                    <div className="border arrow-down center-by-margin"></div>
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="large-11 large-centered column">
                                        <div className="row">
                                            <div className="large-8 column">
                                                <div className="row project-details-title">{project.name}</div>
                                                <div className="row project-details-desc">
                                                    <pre className="text-style">{project.description}</pre>
                                                </div>
                                                <div className="row project-detail-list">
                                                    <div className="detail-1">
                                                        <div className="detail-logo">
                                                            <img src={project_details_logo1} className="shape"/>
                                                        </div>
                                                        <div className="detail-text">
                                                            {
                                                                project.earliest_audition_date ?
                                                                    <div><b>NEXT AUDITIONS ON</b>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{this.toUpper(this.dateFormat(project.earliest_audition_date))}</div> :
                                                                    <b>NO FUTURE AUDITION DATES AVAILABLE YET</b>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="detail-1">
                                                        <div className="detail-logo">
                                                            <img src={project_details_logo2} className="shape" />
                                                        </div>
                                                        <div className="detail-text">
                                                            <b>AUDITIONING IN</b>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{this.toUpper(project.earliest_audition_location)}
                                                        </div>
                                                    </div>
                                                    <div className="detail-1 hide-content">
                                                        <div className="detail-logo">
                                                            <img src={project_details_logo3} className="shape" />
                                                        </div>
                                                        <div className="detail-text">
                                                            NON UNION
                                                        </div>
                                                    </div>
                                                    <div className="detail-1">
                                                        <div className="detail-logo">
                                                            <img src={project_details_logo4} className="shape" />
                                                        </div>
                                                        <div className="detail-text">
                                                        {
                                                            project.roles_count ?
                                                                <div><b>SEEKING</b>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{project.roles_count} ROLES</div> :
                                                                <b>ALL ROLES HAVE BEEN FULFILLED</b>
                                                        }
                                                        </div>
                                                    </div>
                                                    <div className="detail-1 hide-content">
                                                        <div className="detail-logo">
                                                            <img src={project_details_logo5} className="shape" />
                                                        </div>
                                                        <div className="detail-text">
                                                            SHOOTING&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;23 MAR 2019&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;LOS ANGELES, USA
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="large-3 column padding-on-top">
                                                <div className="row qrcode-area">
                                                    <div className="column small-8 align-right">
                                                        <div className="row add-padding">
                                                            <a className="button qrtext" target="_blank" href="https://v2.auditionmagic.com/login">
                                                                REVIEW AUDITIONS</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row footer2 large-expand">
                            <div className="row register-footer2">
                                <div className="column footer-logo">
                                    <img width="50px" src={amlogo}/>
                                </div>
                                <div className="column">
                                    Powered by Audition Magic copyright © 2018
                                </div>
                            </div>
                        </div>
                    </div>
            </div> : <div></div>
        )
    }
}

CompanyReview = reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(CompanyReview)

const mapStateToProps = state => ({
    project: state.client.project ? state.client.project : null
})


const mapDispatchToProps = (dispatch) => ({
    onLoad: payload =>
        dispatch({ type: 'COMPANY_LANDING_PAGE_DETAILS', payload: payload})
})

export default connect(mapStateToProps, mapDispatchToProps)(CompanyReview)


// WEBPACK FOOTER //
// ./src/containers/CompanyReview.js